<template>
  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a href="#">{{translations('navbar.inventory_control')}}</a>
        </li>
        <li class="breadcrumb-item active" aria-current="page">{{translations('navbar.inventory')}}</li>
      </ol>
    </nav>
    <div class="container-fluid main-container">
      <div class="form-inline mb-2 d-flex flex-wrap" id="collapseExample">
        <div class="form-group mr-2 d-flex align-items-center mt-1">
          <span class="text-nowrap mr-1">{{translations('inventory.inventory_date')}}</span>
<!--          <input type="date" v-model="inventory_at" class="form-control" @blur='triggerDateFilter' @focus="tempDateField = inventory_at">-->
          <input type="date" v-model="inventory_at" class="form-control">
        </div>
        <div class="form-group mr-2 mt-1">
          <div class="dropdown">
            <button id='filterByWarehouse' class="btn btn-outline-secondary dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{{ selectWarehouse(warehouse_id) }}</button>
            <div class="dropdown-menu">
              <a class='dropdown-item' v-on:click="warehouse_id=0">{{translations('inventory.select_warehouse')}}</a>
              <a class='dropdown-item' v-for='(warehouse, i) in warehouses' :key='i' v-on:click="warehouse_id=warehouse.id">{{ selectWarehouse(warehouse.id) }}</a>
            </div>
          </div>
        </div>
        <div class="form-group mr-2 mt-1" v-for="(condition, i) in conditions" :key='i'>
          <div class="form-check">
            <input class="form-check-input pointer-clickable" type="radio" :value="condition.value" :id='condition.id' v-model="selectedCondition">
            <label class="form-check-label pointer-clickable" :for="condition.id">
              {{condition.name}}
            </label>
          </div>
        </div>
        <div class="form-group mr-1 ml-4 mt-1">
          <div class="dropdown">
            <button id='filterByStatus' class="btn btn-outline-secondary dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{{ selectStatus(status_id) }}</button>
            <div class="dropdown-menu">
              <a class='dropdown-item' v-on:click="status_id=0">{{translations('inventory.estimation_status')}}</a>
              <a class='dropdown-item' v-for='(status, i) in statuses' :key='i' v-on:click="status_id=status.id">{{ selectStatus(status.id) }}</a>
            </div>
          </div>
        </div>
        <div class="form-group mr-1 mt-1">
          <div class="dropdown">
            <button id='filterByPersonal' class="btn btn-outline-secondary dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{{ selectPersonal(personal_id) }}</button>
            <div class="dropdown-menu">
              <a class='dropdown-item' v-on:click="personal_id=0">{{translations('inventory.manager')}}</a>
              <a class='dropdown-item' v-for='(personal, i) in personals' :key='i' v-on:click="personal_id=personal.id">{{ selectPersonal(personal.id) }}</a>
            </div>
          </div>
        </div>
        <div class="form-group mr-2 mt-1">
          <div class="form-group mr-1">
            <input id='dtSearch' type="text" class="form-control" v-model='dtSearch' :placeholder="translations('common.keyword_search')">
          </div>
        </div>
<!--         <div class="form-group">
          <a class="btn btn-link btn-sm decoration-underline" @click="loadPDF()" href="#">印刷用PDFの表示<i class="fas fa-external-link-alt"></i></a>
        </div> -->
        <div class="form-group mr-2 mt-1">
          <div class="form-group">
            <label class="pointer-clickable">
              <input id='displayAll' v-model="displayAll" type="checkbox" class="form-control mr-1 pointer-clickable" @change='triggerDisplayAll()' >
              <span>{{translations('common.display_all')}}</span>
            </label>
          </div>
        </div>
        <div class="form-group">
          <button class="btn btn-primary btn-sm" type="button" @click="submitSearch">{{translations('common.search')}}</button>
        </div>
        <div class="ml-auto mt-1">
          <div class="d-flex align-items-center">
            <button type="button" class="btn border mr-2" @click="loadPDF()" >{{translations('inventory.print_pdf')}}</button>
            <button class="btn btn-sm btn-link p-0 decoration-underline margin-right-10" type="button" @click="export_csv()" >{{translations('inventory.download_csv')}}</button>
          </div>
        </div>
      </div>
      <div class="table-scroll mb-4">
        <v-data-table
          class="table table-striped table-hover table-clickable"
          item-key="name"
          :search="dtSearch"
          :headers="[
            { text: translations('inventory.estimation_status'), value: 'in_stock_status' },
            { text: translations('inventory.reference_number'), value: 'refNo', sortable: false },
            { text: translations('inventory.stocktaking_date'), value: 'inventory_checked_at' },
            { text: translations('inventory.manager'), value: 'personnel' },
            { text: translations('inventory.jan_code'), value: 'jan_code' },
            { text: translations('inventory.item_no'), value: 'item_no' },
            { text: translations('inventory.legacy_code'), value: 'legacy_code' },
            { text: translations('inventory.model'), value: 'type_number' },
            { text: translations('inventory.cost_price'), value: 'original_price_jpy'},
            { text: translations('inventory.ledger_count'), value: 'amount' },
            { text: translations('inventory.ledger_amount'), value: 'original_price_jpy_total' },
            { text: translations('inventory.actual_quantity'), value: 'his_quantity' },
            { text: translations('inventory.actual_amount'), value: 'history_price_jpy_total' },
            { text: translations('inventory.discrepancy_number'), value: 'diff_count' },
            { text: translations('inventory.discrepancy_amount'), value: 'diff_price_jpy_total' },
            { text: translations('inventory.remarks'), value: 'note' },
            { text: translations('inventory.correction'), value: 'edit' },
            // { text: '数量', value: 'his_quantity' },
            // { text: '棚卸し前', value: 'amount' },
            { text: translations('inventory.operation') },
            { text: '' }
          ]"
          :items="filterInventories"
          hide-default-footer
          :page.sync="page"
          :items-per-page="itemsPerPage"
          @page-count="pageCount = $event"
          @current-items="currentItems"
        >
          <template v-slot:body="{ items }">
            <tbody class="">
              <template v-if="!isEmpty">
                <tr v-for="(inventory, i) in items" :key='i' >
                  <td @dblclick="openUpdateModal(inventory)">
                    <span class="badge" :class="statusId(inventory.inventory_checked_at) === 2 ? 'badge-success' : 'badge-light'">
                      {{ statusId(inventory.inventory_checked_at) === 2 ? translations('inventory.processed') : translations('inventory.unprocessed') }}
                    </span>
                  </td>
                  <td> {{ i + 1 }} </td>
                  <td @dblclick="openUpdateModal(inventory)">{{ inventory.inventory_checked_at === '1970-01-01' ? '' : $invoiceTools.formatDate(inventory.inventory_checked_at) }}</td>
                  <td @dblclick="openUpdateModal(inventory)">{{ inventory.personnel }}</td>
                  <td @dblclick="openUpdateModal(inventory)">{{ inventory.jan_code }}</td>
                  <td @dblclick="openUpdateModal(inventory)">{{ inventory.item_no }}</td>
                  <td @dblclick="openUpdateModal(inventory)">{{ inventory.legacy_code }}</td>
                  <td @dblclick="openUpdateModal(inventory)">{{ inventory.type_number }}</td>
                  <td @dblclick="openUpdateModal(inventory)">
                    {{ inventory.original_price_jpy ? parseInt(inventory.original_price_jpy).toLocaleString() : 0 }}
                  </td>
                  <td @dblclick="openUpdateModal(inventory)">
                    {{ inventory.amount ? parseInt(inventory.amount).toLocaleString() : 0 }}
                  </td>
                  <td @dblclick="openUpdateModal(inventory)">
                    {{ inventory.original_price_jpy_total ? parseFloat(inventory.original_price_jpy_total).toLocaleString() : 0 }}
                  </td>
                  <td @dblclick="openUpdateModal(inventory)">
                    {{ inventory.his_quantity ? parseInt(inventory.his_quantity).toLocaleString() : 0 }}
                  </td>
                  <td @dblclick="openUpdateModal(inventory)">
                    {{ inventory.history_price_jpy_total ? parseFloat(inventory.history_price_jpy_total).toLocaleString() : 0 }}
                  </td>
                  <td @dblclick="openUpdateModal(inventory)">
                    <span :class="!parseInt(inventory.diff_count) ? 'text-dark' : 'text-danger'">
                      {{ inventory.diff_count ? parseInt(inventory.diff_count).toLocaleString() : 0 }}
                    </span>
                  </td>
                  <td @dblclick="openUpdateModal(inventory)">
                    <span :class="!parseInt(inventory.diff_price_jpy_total) ? 'text-dark' : 'text-danger'">
                      {{ inventory.diff_price_jpy_total ? parseInt(inventory.diff_price_jpy_total).toLocaleString() : 0 }}
                    </span>
                  </td>
                  <td >
                    <div class="d-flex mb-0 align-items-center justify-content-end" style="width: 35px">
                      <PopoverMessageEdit :id="`${inventory.id}-${i}`" v-if="inventory.modified_at || (inventory.note && inventory.note !== '')" :message_edited="message_edited" />
                      <span @click="openNoteModal(inventory)" class="pl-2 pt-1 pointer-clickable">
                        <i class="fas fa-chevron-down"></i>
                      </span>
                    </div>
                  </td>
                  <td>
                    <button class="btn btn-primary btn-sm" type="button" @click="openUpdateModal(inventory)" >{{translations('inventory.correction')}}</button>
                  </td>
                  <!-- <td @click="openUpdateModal(inventory)" class="right">{{ inventory.his_quantity ? inventory.his_quantity.toLocaleString() : 0 }}</td>
                  <td @click="openUpdateModal(inventory)" :class="inventory.difference ? 'right difference' : 'right' ">{{ inventory.amount ? inventory.amount.toLocaleString() : 0 }}</td> -->
                  <td>
                    <button class="btn btn-primary btn-sm" type="button" @click="updateInventoryDate(inventory)" :disabled="statusId(inventory.inventory_checked_at) === 2">{{translations('inventory.no_quantity_change')}}</button>
                  </td>
                  <td>
                    <button class="btn btn-danger btn-sm" type="button" @click="deleteHistory(inventory)" :disabled="!inventory.history_id"><i class="fas fa-trash"></i></button>
                  </td>
                </tr>
              </template>
              <template v-if="isEmpty">
                <tr class="odd">
                  <td valign="top" colspan="12" class="dataTables_empty">{{ isEmptyMsg }}</td>
                </tr>
              </template>
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td><span class="font-weight-bold">{{translations('inventory.total')}}:</span></td>
                <td></td>
                <td>
                  <span class="font-weight-bold">
                    {{ getOriginalQuantity }}
                  </span>
                </td>
                <td>
                  <span class="font-weight-bold">
                    {{ getOriginalPriceTotal.toLocaleString() }}
                  </span>
                </td>
                <td>
                  <span class="font-weight-bold">
                    {{ getHistoryQuantity }}
                  </span>
                </td>
                <td>
                  <span class="font-weight-bold">
                    {{ getHistoryPriceTotal.toLocaleString() }}
                  </span>
                </td>
                <td>
                  <span class="font-weight-bold">
                    {{ getHistoryQuantity - getOriginalQuantity }}
                  </span>
                </td>
                <td>
                  <span class="font-weight-bold">
                    {{ (getHistoryPriceTotal - getOriginalPriceTotal).toLocaleString() }}
                  </span>
                </td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
            </tbody>
          </template>
        </v-data-table>
      </div>

      <ArchiveDatatablePagination :pageCount="pageCount" :page.sync="page" @changePage="page=$event"/>
    </div>
    <ArchiveInventoryAddModal/>
    <ArchiveInventoryUpdateModal
      :detail="inventoryDetail"
      :inventory_at="inventory_at"
      :originalDetail="originalInventoryDetail"
      :selectedCondition="selectedCondition"
      @modal-closed="handleModalClosed"/>
    <ArchiveInventoryNoteModal :detail="inventoryDetail" :inventory_at="inventory_at" :originalDetail="originalInventoryDetail" :selectedCondition="selectedCondition"/>
    <vue-element-loading :active="isSearching" :is-full-screen="true"/>
  </div>
</template>

<script>
import VueElementLoading from 'vue-element-loading'
import ArchiveInventoryAddModal from '@/components/ArchiveInventoryAddModal'
import ArchiveInventoryUpdateModal from '@/components/ArchiveInventoryUpdateModal'
import ArchiveDatatablePagination from '@/components/ArchiveDatatablePagination'
import ArchiveInventoryNoteModal from '@/components/ArchiveInventoryNoteModal'
import PopoverMessageEdit from '@/components/PopoverMessageEdit'
import { inventoryStatus } from '../constants'

import { saveAs } from 'file-saver'
import { format } from 'date-fns'
import { mapState } from 'vuex'

var PapaParse = require('papaparse')
var encoding = require('encoding-japanese')

export default {
  name: 'ArchiveInventories',
  props: {},
  components: {
    VueElementLoading,
    ArchiveInventoryAddModal,
    ArchiveInventoryUpdateModal,
    ArchiveDatatablePagination,
    ArchiveInventoryNoteModal,
    PopoverMessageEdit
  },
  watch: {
    dtSearch (v) {
      this.$storage.set('ArchiveInventories:dtSearch', v) // KEEP KEYWORD
    },
    warehouse_id (val) {
      // this.listInventories()

      let params = this.$storage.get('ArchiveInventoriesParam')
      if (!params) params = {}
      params.warehouses_id = val
      this.$storage.set('ArchiveInventoriesParam', params)
    },
    status_id (val) {
      let params = this.$storage.get('ArchiveInventoriesParam')
      if (!params) params = {}
      params.status_id = val
      this.$storage.set('ArchiveInventoriesParam', params)
    },
    personal_id (val) {
      let params = this.$storage.get('ArchiveInventoriesParam')
      if (!params) params = {}
      params.personal_id = val
      this.$storage.set('ArchiveInventoriesParam', params)
    },
    inventory_at (val) {
      let params = this.$storage.get('ArchiveInventoriesParam')
      if (!params) params = {}
      params.inventory_at = val
      this.$storage.set('ArchiveInventoriesParam', params)
    },
    selectedCondition (val) {
      // this.listInventories()

      let params = this.$storage.get('ArchiveInventoriesParam')
      if (!params) params = {}
      params.selectedCondition = val
      this.$storage.set('ArchiveInventoriesParam', params)
    },
    currentLanguage (newLang, oldLang) {
      this.listStatuses()
      this.updateConditions()
    }
  },
  data () {
    return {
      dtSearch: this.$storage.get('ArchiveInventories:dtSearch') || '',
      isSearching: false,
      searchInventories: [],
      warehouses: [],
      warehouse_id: 0,
      statuses: [],
      status_id: 0,
      personals: [],
      personal_id: 0,
      inventories: [],
      inventory_at: null,
      isEmpty: false,
      isEmptyMsg: '',
      inventoryDetail: {},
      originalInventoryDetail: {},
      pdf: '',
      page: 1,
      pageCount: null,
      itemsPerPage: 10,
      selectedCondition: 0,
      // tempDateField: null,
      displayAll: false,
      message_edited: '編集されたレコード'
    }
  },
  computed: {
    ...mapState(['currentLanguage']),
    statusId () {
      return (date) => {
        return this.getStatusId(date)
      }
    },
    filterInventories () {
      let inventories = this.inventories
      // 棚卸し日
      if (Number(this.status_id) === 1) {
        inventories = inventories.filter(inventory => {
          return this.getStatusId(inventory.inventory_checked_at) === 1
        })
      } else if (Number(this.status_id) === 2) {
        inventories = inventories.filter(inventory => {
          return this.getStatusId(inventory.inventory_checked_at) === 2
        })
      }

      // 担当者
      if (Number(this.personal_id) > 0) {
        inventories = inventories.filter(inventory => {
          return inventory.personal_id === this.personal_id
        })
      }

      inventories = inventories.filter(inventory => {
        return !(Number(inventory.amount) === 0 &&
          Number(inventory.his_quantity) === 0 &&
          Number(inventory.diff_count) === 0 &&
          Number(inventory.original_price_jpy_total) === 0 &&
          Number(inventory.history_price_jpy_total) === 0)
      })

      return inventories
    },
    selectWarehouse () {
      return (warehouseId) => {
        const warehouse = this.warehouses.find(w => w.id === warehouseId)
        if (!warehouse) return this.translations('inventory.select_warehouse')
        return warehouse.name
      }
    },
    selectStatus () {
      return (statusId) => {
        const status = this.statuses.find(s => s.id === statusId)
        if (!status) return this.translations('inventory.estimation_status')
        return status.name
      }
    },
    selectPersonal () {
      return (personalId) => {
        const personal = this.personals.find(p => p.id === personalId)
        if (!personal) return this.translations('inventory.manager')
        return personal.name
      }
    },
    selectConditionName () {
      return (conditionId) => {
        const condition = this.conditions.find(c => c.value === conditionId)
        return condition.name
      }
    },
    getOriginalQuantity () {
      const inventories = this.isFilterInventories ? this.filterInventories : this.searchInventories
      return inventories.reduce((prevValue, currentValue) => prevValue + (Number(currentValue.amount) || 0), 0)
    },
    getHistoryQuantity () {
      const inventories = this.isFilterInventories ? this.filterInventories : this.searchInventories
      return inventories.reduce((prevValue, currentValue) => prevValue + (Number(currentValue.his_quantity) || 0), 0)
    },
    getOriginalPriceTotal () {
      const inventories = this.isFilterInventories ? this.filterInventories : this.searchInventories
      return inventories.reduce((prevValue, currentValue) => prevValue + (Number(currentValue.original_price_jpy_total) || 0), 0)
    },
    getHistoryPriceTotal () {
      const inventories = this.isFilterInventories ? this.filterInventories : this.searchInventories
      return inventories.reduce((prevValue, currentValue) => prevValue + (Number(currentValue.history_price_jpy_total) || 0), 0)
    },
    isFilterInventories () {
      return (this.dtSearch === '' && this.searchInventories.length)
    }
  },
  created: async function () {
    this.isSearching = true

    let storedFilter = this.$storage.get('ArchiveInventoriesParam')
    if (storedFilter) {
      this.personal_id = storedFilter.personnel_id
      this.warehouse_id = storedFilter.warehouses_id
      this.status_id = storedFilter.status_id
      this.inventory_at = storedFilter.inventory_at
      this.selectedCondition = storedFilter.selectedCondition || 0
    }

    if (!this.inventory_at) {
      this.inventory_at = this.$invoiceTools.getCurrentDate()
    }

    await this.listInventories()
    await this.listWarehouses()
    await this.listStatuses()
    await this.listPersonals()
    this.updateConditions()
    this.isSearching = false
  },
  methods: {
    translations (key) {
      const language = require(`@/locales/${this.currentLanguage}.json`)
      const keys = key.split('.')
      let value = language

      for (const k of keys) {
        value = value[k]
        if (!value) break
      }

      return value || key
    },
    async listWarehouses () {
      try {
        let cList = await this.$http.post(this.$api_url.warehouse_list)
        let $data = this.$invoiceTools.prepareResult(cList.data, 'list', 'ArchiveInventories:listWarehouses')
        if ($data.success === true) {
          this.warehouses = $data.data
        } else {
          this.warehouses = [{ id: 0, name: 'No record.' }]
        }
      } catch (error) {
        console.log('ArchiveInventories:listWarehouses:catch(error): ', JSON.stringify(error))
        this.$toastr.error('エラーのため失敗しました。ご確認後、再試行してください。', 'エラー')
      }
    },

    async listStatuses () {
      try {
        let cList = await this.$http.post(this.$api_url.inventory_status_list)
        let $data = this.$invoiceTools.prepareResult(cList.data, 'list', 'ArchiveInventories:listStatuses')
        if ($data.success === true) {
          const translatedStatuses = this.translateStatuses($data.data)
          this.statuses = translatedStatuses
        } else {
          this.statuses = [{ id: 0, name: 'No record.' }]
        }
      } catch (error) {
        console.log('ArchiveInventories:listStatuses:catch(error): ', JSON.stringify(error))
        this.$toastr.error('エラーのため失敗しました。ご確認後、再試行してください。', 'エラー')
      }
    },

    translateStatuses (statuses) {
      return statuses.map(status => ({
        ...status,
        name: this.translations(`statuses.${status.name}`)
      }))
    },

    updateConditions () {
      this.conditions = [
        { id: 'good', name: this.translations('inventory.good'), value: 0 },
        { id: 'bad', name: this.translations('inventory.bad'), value: 1 },
        { id: 'outlet', name: this.translations('inventory.outlet'), value: 2 }
      ]
    },

    async listPersonals () {
      try {
        let cList = await this.$http.post(this.$api_url.inventory_personal_list)
        let $data = this.$invoiceTools.prepareResult(cList.data, 'list', 'ArchiveInventories:listPersonals')

        if ($data.success === true) {
          this.personals = $data.data
        } else {
          this.personals = [{ id: 0, name: 'No record.' }]
        }
      } catch (error) {
        console.log('ArchiveInventories:listPersonals:catch(error): ', JSON.stringify(error))
        this.$toastr.error('エラーのため失敗しました。ご確認後、再試行してください。', 'エラー')
      }
    },

    async listInventories () {
      if (!this.warehouse_id || !this.inventory_at) {
        return
      }

      this.isSearching = true

      try {
        const params = {
          warehouses_id: this.warehouse_id,
          inventory_at: this.inventory_at,
          condition: this.selectedCondition
        }
        console.log('ArchiveInventories:' + this.$api_url.inventory_list + ':params -- ', JSON.stringify(params))

        let inventoriesList = await this.$http.post(this.$api_url.inventory_list, params)
        let $data = this.$invoiceTools.prepareResult(inventoriesList.data, 'list', 'ArchiveInventories:listInventories')

        if ($data.success === true) {
          this.inventories = $data.data
        } else {
          this.inventories = []
          this.$toastr.error($data.data, 'エラー')
        }
      } catch (error) {
        console.log('ArchiveInventories:listInventories:catch(error): ', JSON.stringify(error))
        this.$toastr.error('エラーのため失敗しました。ご確認後、再試行してください。', 'エラー')
      }

      this.isSearching = false
    },

    async updateInventoryDate (inventory) {
      this.isSearching = true
      let currentTime = format(new Date(), 'HH:mm')
      try {
        let params = {
          warehouses_id: this.warehouse_id,
          stock_id: inventory.id,
          quantity: inventory.his_quantity,
          last_date: inventory.inventory_checked_at,
          date: format(new Date(`${this.inventory_at} ${currentTime}`), "yyyy-MM-dd'T'HH:mm:59"),
          product_id: inventory.product_id,
          selectedCondition: this.selectedCondition
        }
        console.log('ArchiveInventories:' + this.$api_url.inventory_update + ':params -- ', JSON.stringify(params))

        let updateOrder = await this.$http.post(this.$api_url.inventory_update, params)
        let $data = this.$invoiceTools.prepareResult(updateOrder.data, '', 'ArchiveInventories:updateInventoryDate')
        if ($data.success === true) {
          this.$toastr.success('成功しました。', 'Success')
          inventory.inventory_checked_at = updateOrder.data.closing_date
          inventory.personnel = updateOrder.data.personnel
          inventory.id = updateOrder.data.stock_id
          inventory.history_id = updateOrder.data.history_id
        } else {
          this.$toastr.error($data.data, 'エラー')
        }
        this.isSearching = false
      } catch (error) {
        this.isSearching = false
        console.log('ArchiveInventories:updateInventoryDate:catch(error): ', JSON.stringify(error))
        this.$toastr.error('エラーのため失敗しました。ご確認後、再試行してください。', 'エラー')
      }
    },

    openUpdateModal (inventory) {
      inventory.warehouse_id = this.warehouse_id
      this.inventoryDetail = inventory
      this.originalInventoryDetail = window.$.extend({}, inventory)
      window.$('#ArchiveInventoryUpdateModal').modal('show')
    },

    openNoteModal (inventory) {
      inventory.warehouse_id = this.warehouse_id
      this.inventoryDetail = inventory
      this.originalInventoryDetail = window.$.extend({}, inventory)
      window.$('#ArchiveInventoryNoteModal').modal('show')
    },

    async loadPDF () {
      if (this.warehouse_id === undefined || this.warehouse_id === 0) {
        this.$toastr.warning('倉庫を選択してください。')
        return
      }

      try {
        let params = {
          warehouses_id: this.warehouse_id,
          inventory_at: this.inventory_at,
          condition: this.selectedCondition,
          process_status: this.status_id,
          personal_id: this.personal_id,
          search: this.dtSearch
        }
        this.isSearching = true

        console.log('ArchiveInventories:' + this.$api_url.inventory_pdf + ':params -- ', JSON.stringify(params))

        let inventoriesList = await this.$http.post(this.$api_url.inventory_pdf, params)
        if (inventoriesList.data.status === true) {
          this.pdf = inventoriesList.data.pdf

          let arrBuff = this.__b64ToArrayBuffer(this.pdf.replace('data:application/pdf;base64,', ''))
          const pdfFile = new Blob([arrBuff], { type: 'application/pdf' })
          const pdfFileURL = URL.createObjectURL(pdfFile)
          let a = document.createElement('a')
          a.href = pdfFileURL
          a.download = `棚卸し結果 ${format(new Date(), 'yyyyMMdd_HHmmss')}.pdf`
          a.click()
        } else {
          this.$toastr.error(inventoriesList.data, 'エラー')
        }
        this.isSearching = false
      } catch (error) {
        console.log('ArchiveInventories:loadPDF:catch(error): ', JSON.stringify(error))
        this.$toastr.error('エラーのため失敗しました。ご確認後、再試行してください。', 'エラー')
        this.isSearching = false
      }
    },

    __b64ToArrayBuffer (base64) {
      let binaryString = window.atob(base64)
      let len = binaryString.length
      let bytes = new Uint8Array(len)
      for (let i = 0; i < len; i++) {
        bytes[i] = binaryString.charCodeAt(i)
      }
      return bytes.buffer
    },

    async deleteHistory (inventory) {
      this.isSearching = true
      const params = {
        history_id: inventory.history_id,
        inventory_at: this.inventory_at,
        condition: this.selectedCondition
      }
      this.$http.post(this.$api_url.inventory_remove, params).then(response => {
        const result = response.data
        if (result.status === true) {
          const index = this.inventories.findIndex(i => i.history_id === inventory.history_id)
          if (result.next) {
            const inventories = JSON.parse(JSON.stringify(this.inventories))
            inventories[index] = result.next
            this.inventories = inventories
          } else {
            this.inventories.splice(index, 1)
          }

          this.$toastr.success('棚卸し履歴を削除しました。', 'Success')
          this.listInventories()
        }
      })
      this.isSearching = false
    },

    getStatusId (date) {
      if (!date) return 1 // 未処理
      if (!this.inventory_at) return 2 // 処理済
      return (date >= this.inventory_at) ? 2 : 1
    },

    triggerDateFilter () {
      if (this.inventory_at !== this.tempDateField) {
        this.listInventories()
      }
    },

    export_csv () {
      const CSV_FIELD = [
        { id: 1, name: '棚卸し日', key: 'inventory_checked_at' },
        { id: 2, name: '担当者', key: 'personnel' },
        { id: 3, name: 'JAN コード', key: 'jan_code' },
        { id: 4, name: 'Item No.', key: 'item_no' },
        { id: 5, name: 'レガシーコード', key: 'legacy_code' },
        { id: 6, name: '製品名', key: 'type_number' },
        { id: 7, name: '原価', key: 'original_price_jpy' },
        { id: 8, name: '帳薄数', key: 'amount' },
        { id: 9, name: '帳薄額', key: 'original_price_jpy_total' },
        { id: 10, name: '実地数', key: 'his_quantity' },
        { id: 11, name: '実地額', key: 'history_price_jpy_total' },
        { id: 12, name: '差異数', key: 'diff_count' },
        { id: 13, name: '差異額', key: 'diff_price_jpy_total' }
      ]
      const csvFieldName = []
      const csvFieldKeys = []
      for (let i = 0; i < CSV_FIELD.length; i++) {
        csvFieldName.push(CSV_FIELD[i].name)
        csvFieldKeys.push(CSV_FIELD[i].key)
      }

      let csvData = []
      let tempInventories = (this.dtSearch !== '' || this.filterInventories.length <= 10) ? this.searchInventories : this.filterInventories
      const csvFieldWareHouse = ['倉庫名', this.selectWarehouse(this.warehouse_id)]
      const csvFieldCondition = ['製品タイプ', this.selectConditionName(this.selectedCondition)]

      let filterTempInventories = tempInventories.reduce((prevInventory, curInventory) => {
        if (!(Number(curInventory.amount) === 0 &&
          Number(curInventory.his_quantity) === 0 &&
          Number(curInventory.diff_count) === 0 &&
          Number(curInventory.original_price_jpy_total) === 0 &&
          Number(curInventory.history_price_jpy_total) === 0)) {
          prevInventory.push(curInventory)
        }
        return prevInventory
      }, [])

      csvData = filterTempInventories.reduce((prevInventory, curInventory) => {
        const csvTemp = []
        csvFieldKeys.map(key => {
          if (key === 'in_stock_status') {
            csvTemp.push(this.statusId(curInventory.inventory_checked_at) === inventoryStatus.PROCESSED ? this.translations('inventory.processed') : this.translations('inventory.unprocessed'))
          } else {
            csvTemp.push(curInventory[key])
          }
        })
        prevInventory.push(csvTemp)
        return prevInventory
      }, [csvFieldWareHouse, csvFieldCondition, csvFieldName])

      const listTotal = [
        '合計:',
        this.getOriginalQuantity,
        this.getOriginalPriceTotal.toLocaleString(),
        this.getHistoryQuantity,
        this.getHistoryPriceTotal.toLocaleString(),
        this.getHistoryQuantity - this.getOriginalQuantity,
        (this.getHistoryPriceTotal - this.getOriginalPriceTotal).toLocaleString()
      ]

      csvData.push(new Array(6).fill('').concat(listTotal))

      const csv = PapaParse.unparse({
        data: csvData
      })

      const unicodeList = encoding.stringToCode(csv)
      const sjisArray = encoding.convert(unicodeList, 'UTF8', 'UNICODE')
      const uInt8List = new Uint8Array(sjisArray)
      const content = new Blob([
        new Uint8Array([0xEF, 0xBB, 0xBF]), uInt8List
      ], { type: 'text/csv' })

      const filename = `棚卸し ${format(new Date(), 'yyyyMMdd_HHmmss')}.csv`

      saveAs(content, filename)
    },

    triggerDisplayAll () {
      if (this.displayAll) {
        this.itemsPerPage = -1 // DISPLAY ALL
      } else {
        this.itemsPerPage = 10 // DISPLAY 10 ROWs
      }
    },

    currentItems (value) {
      this.searchInventories = value
    },

    submitSearch () {
      this.listInventories()
    },
    handleModalClosed () {
      window.location.reload()
    }
  }
}
</script>

<style>
#tbl-inventories_wrapper .col-sm-12{
  padding-right: 0 !important;
}
.difference {
  font-weight: bold;
  color: red;
}
</style>
